export const ATTR_NAMES_LEAD = {
    agentName: 'agentName',
    selfEmployed: 'selfEmployed',
    mtsProductCodes: 'mtsProductCodes',
    contactFio: 'contactFio',
    selfEmployedFio: 'selfEmployedFio',
    email: 'email',
    agentWorkEmail: 'agentWorkEmail',
    phoneNumber: 'phoneNumber',
    legalName: 'legalName',
    inn: 'inn',
    ogrn: 'ogrn',
    regionId: 'regionId',
    serviceProvisionAddress: 'serviceProvisionAddress',
    comment: 'comment',
    error: 'error',
} as const;
